import { Injectable } from '@angular/core';
import { LoadModuleReferences } from './models/load-module-reference.model';

@Injectable({
  providedIn: 'root'
})
export class LazyloadService {
  lazyModuleReferences: LoadModuleReferences = {};
  constructor() { }
}
